export const TransferRecordsTypes = {
    GET_TRANSFER_RECORDS:'GET_TRANSFER_RECORDS',
}